import { useContext, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Card from "../../../../components/cards/Card";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { Header, StyledDialog } from "../styles/GerenciamentoContrato";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import useGerenciamentoContratoListagemController from "../controllers/GerenciamentoContratoListagemController";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";

const ModalCancelaServicoAvulso = ({
  open,
  setOpen,
  handleMain = () => {},
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { reasonForCancellation, setReasonForCancellation } = useContext(
    GerenciamentoContratoContext
  );

  const { handleSelectReasonForCancellatio } =
    useGerenciamentoContratoListagemController();

  const [modalReasonForCancellatioOpen, setModalReasonForCancellatioOpen] =
    useState(false);

  const columnsTypeServiceModal = [
    { label: "Descrição", id: "descricao" },
    { label: "Ativo", id: "liberado" },
  ];
  const [errorInput, setErrorInput] = useState({});

  const handleCancel = () => {
    const validateSubmit = validNotNull([
      { key: "reasonForCancellation", value: reasonForCancellation },
    ]);

    setErrorInput({ ...validateSubmit?.errorsValidation });

    if (validateSubmit?.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );
    handleMain();
    handleClose();
  };

  const handleClose = () => {
    setReasonForCancellation(null);
    setOpen(false);
  };

  return (
    <>
      {modalReasonForCancellatioOpen && (
        <SearchDialog
          open={modalReasonForCancellatioOpen}
          setOpen={setModalReasonForCancellatioOpen}
          columns={columnsTypeServiceModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectReasonForCancellatio}
          route={`faturamento/motivoscancelamentos/v1/getporempresa/${queryParams.empresa_id}`}
          title="MOTIVO DE CANCELAMENTO"
          where={{ liberado: "S", tipo_status: "C" }}
        />
      )}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-cancelamento-contrato"
      >
        <StyledDialog>
          <DialogTitle id="dialog-title">
            <Header>
              <Grid container align="center" justifyContent="center">
                <Chip
                  bgcolor="tertiary"
                  textcolor="white"
                  label="CANCELAR SERVIÇO"
                />
              </Grid>
            </Header>
          </DialogTitle>
          <DialogContent>
            <Card chipcolor="transparent" fullWidth={true}>
              <Grid item container xs spacing={2}>
                <Grid item xs>
                  <SearchSelect
                    descriptionField="descricao"
                    label="Motivo de cancelamento"
                    value={reasonForCancellation}
                    setValue={setReasonForCancellation}
                    route={`faturamento/motivoscancelamentos/v1/getporempresa/${queryParams.empresa_id}`}
                    filter="descricao"
                    variant="filled"
                    error={errorInput?.reasonForCancellation ? true : false}
                    where={{ liberado: "S", tipo_status: "C" }}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Btn
                    label={<SearchIcon />}
                    full="true"
                    onClick={() => setModalReasonForCancellatioOpen(true)}
                    bgcolor="tertiary"
                  />
                </Grid>
              </Grid>
            </Card>
          </DialogContent>
          <DialogActions>
            <Btn onClick={handleClose} bgcolor="darkred" label="Cancelar" />
            <Btn
              onClick={handleCancel}
              bgcolor="primary"
              label="Realizar Cancelamento"
            />
          </DialogActions>
        </StyledDialog>
      </Dialog>
    </>
  );
};

export default ModalCancelaServicoAvulso;
